import Phaser from 'phaser';
import ABCyaPhaser from '@abcya/abcya_phaser';
import GameBackground from '../mathLines/GameBackground';
import Dino from '../mathLines/Dino';
import MathLinesInst from '../mathLines/MathLinesInst';
import SoundAssetKeys from '../SoundAssetKeys';

export default class Instructions extends Phaser.Scene {
  static get KEY() { return 'Instructions'; }

  create() {
    console.log('Instructions');

    this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._math_lines_music, this, .5, true);

    this.anims.create({ key: 'char-1-extra', frames: this.anims.generateFrameNames('UIAssets', { prefix: 'char-1-extra_', start: 1, end: 6 }), frameRate: 20 });
    this.anims.create({ key: 'char-1-happy', frames: this.anims.generateFrameNames('UIAssets', { prefix: 'char-1-happy_', start: 1, end: 7 }), frameRate: 20 });
    this.anims.create({ key: 'char-2-extra', frames: this.anims.generateFrameNames('UIAssets', { prefix: 'char-2-extra_', start: 1, end: 6 }), frameRate: 20 });
    this.anims.create({ key: 'char-2-happy', frames: this.anims.generateFrameNames('UIAssets', { prefix: 'char-2-happy_', start: 1, end: 6 }), frameRate: 20 });
    this.anims.create({ key: 'eyes-1-blink', frames: this.anims.generateFrameNames('UIAssets', { prefix: 'eyes-1-blink_', start: 1, end: 3 }), frameRate: 20 });
    this.anims.create({ key: 'eyes-2-blink', frames: this.anims.generateFrameNames('UIAssets', { prefix: 'eyes-2-blink_', start: 1, end: 3 }), frameRate: 20 });

    this.bg = new GameBackground(this, this.mid.x * 2, this.mid.y * 2);
    this.bg.addBackgroundImage('sky-bg');
    this.bg.setClouds(true);

    this.trees = [];
    this.plantTree(90, this.mid.y * 2 - 100);
    this.plantTree(936, this.mid.y * 2 - 100);

    this.char1 = new Dino(this, 1);
    this.char1.x = -(this.char1.getBounds().width + 50);
    this.char1.endX = this.char1.getBounds().width / 2;
    this.char1.y = this.mid.y * 2 - 50;

    this.char2 = new Dino(this, 2);
    this.char2.x = -(this.char2.getBounds().width + 50);
    this.char2.endX = this.mid.x * 2 - this.char2.getBounds().width / 2 - 20;
    this.char2.y = this.mid.y * 2 - this.char2.getBounds().height / 2 - 50;

    this.time.delayedCall(700, () => {
      this.addPopUp();

      this.time.delayedCall(300, () => {
        this.addCharacters();
      });
    });
  }

  addPopUp() {
    this.popUp = new MathLinesInst(this);
    this.children.moveTo(this.popUp, 1);

    this.popUp.once('INST_FINISHED', () => {this.finishInst();});
  };

  addCharacters() {
    this.char1.walkIn(this.char1.endX, 1000);
    this.char2.walkIn(this.char2.endX, 2000);
  };

  finishInst() {
    this.char1.danceAcross(2000);
    this.char2.danceAcross(1500);

    this.time.delayedCall(2100, () => {this.cleanUp();});
  };

  plantTree(xPos,yPos) {
    const tree = ABCyaPhaser.Images.addImage(0, 0, 'tree', this).setOrigin(.5, 1);
    tree.x = xPos;
    tree.y = yPos;
    tree.scaleY = 0;
    tree.alpha = 0;
    this.trees.push(true);

    ABCyaPhaser.Tweens.addTween(tree, 700, { alpha: 1, scaleY: 1 }, Phaser.Math.Easing.Back.Out);
  };

  update() {
    if (this.char1) this.char1.tick();
    if (this.char1) this.char2.tick();
  };

  cleanUp() {
    this.sound.stopAll();
    this.tweens.killAll();

    this.scene.start('Game');
  };
}